import { useFormContext } from 'react-hook-form';
import { Grid2 } from '@mui/material';
import TextFieldComponent from '../../../../../../components/TextFieldComponent';
import ButtonComponent from '../../../../../../components/ButtonComponent';
import { Check, LocalOffer } from '@mui/icons-material';
import ChipListComponent from '../../../../../../components/ChipListComponent';
import React, { useState, FormEvent } from 'react';
import { t } from 'i18next';

interface VehicleTagsProps {
    disabled?: boolean;
}

const VehicleTags = ({ disabled }: VehicleTagsProps) => {
    const { watch, setValue } = useFormContext<{ vehicleTags: string[] | null }>();
    const [newTag, setNewTag] = useState<string>('');

    //garante que tags seja sempre um array para o map
    const tags = watch('vehicleTags') || [];

    const handleAddTag = (event?: FormEvent) => {
        if (event) event.preventDefault();

        //remove tudo que n�o for letra ou n�mero (bloqueia emojis/s�mbolos)
        const tagValue = newTag.trim().replace(/[^A-Z0-9]/gi, '').toUpperCase();

        if (tagValue.length > 0 && !tags.includes(tagValue)) {
            setValue('vehicleTags', [...tags, tagValue], {
                shouldValidate: true,
                shouldDirty: true,
            });
            setNewTag('');
        }
    };

    const onDelete = (index: number) => {
        const updatedTags = tags.filter((_, i) => i !== index);
        const finalValue = updatedTags.length > 0 ? updatedTags : null;

        setValue('vehicleTags', finalValue, {
            shouldValidate: true,
            shouldDirty: true,
        });
    };

    return (
        <>
            <form
                style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    marginBottom: '8px',
                    width: '100%',
                }}
                onSubmit={handleAddTag}
            >
                <TextFieldComponent
                    label={t('recognitionPage.modalEditFace.vehicleTags')}
                    value={newTag}
                    onChangeText={setNewTag}
                    disabled={disabled}
                    maxLength={24}
                    sx={{
                        flexGrow: 1,
                        '& .MuiOutlinedInput-root': {
                            height: '56px',
                            '& fieldset': {
                                borderBottomRightRadius: 0,
                                borderTopRightRadius: 0,
                            },
                        },
                        '& .MuiFormHelperText-root': {
                            position: 'absolute',
                            bottom: '-20px',
                        },
                    }}
                />
                <ButtonComponent
                    disabled={disabled}
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{
                        borderBottomLeftRadius: 0,
                        borderTopLeftRadius: 0,
                        height: '56px',
                        minWidth: '56px',
                        boxShadow: 'none',
                        backgroundColor: (theme) => theme.palette.primary.main,
                        '&:hover': {
                            backgroundColor: (theme) => theme.palette.primary.dark,
                        },
                    }}
                >
                    <Check />
                </ButtonComponent>
            </form>

            {tags.length > 0 && (
                <Grid2 size={12} sx={{ mb: 2 }}>
                    <ChipListComponent
                        chipIcon={<LocalOffer />}
                        chipData={tags}
                        onDelete={onDelete}
                    />
                </Grid2>
            )}
        </>
    );
};

export default VehicleTags;